import { Button, InlineLoading } from "@carbon/react";
import { useTranslation } from "react-i18next";

const ErrorPanel404 = ({ panel, reloadPanel, loading }) => {
    const { t } = useTranslation();
    return (
        <div id={'panel_placeholder' + panel.id} className='panel-placeholder'>
            <h2>{t("panels.noChartData")}</h2>
            <h3>{panel.name}</h3>
            <div className={'reload-holder'}>
                <Button
                    className={'reload-button'}
                    disabled={Boolean(loading)}
                    onClick={reloadPanel}
                >
                    {t("common.reload")}
                </Button>
                {loading !== undefined ? (
                    <InlineLoading
                        status={loading ? 'active' : 'inactive'}
                        iconDescription={t("common.loading")}
                        description=""
                    />
                ) : (
                    <div className={'reload-loading-placeholder'} />
                )}
            </div>
        </div>
    )
}
export default ErrorPanel404;
